import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { FilterType } from '@/hooks/useLobbyUI';
import { GameType } from '@/models/games/enums/GameType';
import { getBetSummaryReportState } from '@/modules/report/selector';
import { betSummarySliceActions } from '@/modules/report/slice/betSummary';
import { RootState } from '@/store/store';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircleIcon from '@mui/icons-material/Circle';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import '../index.scss';
enum CombineGameType { //For bet record
    BlackJack = GameType.Blackjack | GameType.Blackjack2,
}
const getGameType = (gt: string) => {
    let ncgt = Number(gt);
    if ((CombineGameType.BlackJack & ncgt) > 0) {
        ncgt = CombineGameType.BlackJack;
    }
    return ncgt;
};

export const GameTypeSelector = () => {
    const dispatch = useDispatch();

    const { allGameType, selectedFilterType } = useSelector(
        (state: RootState) => getBetSummaryReportState(state)
    );

    const { playButtonAudio } = useContext(AudioPlayContext);

    const id = 'game-type-menu';
    const { t } = useTranslation();

    const [dropdown, setDropdown] = useState<Array<number>>([]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        playButtonAudio();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleChangeType = (c: FilterType) => {
        let lgt = selectedFilterType;
        if (c === dropdown[0]) {
            lgt = lgt === dropdown[0] ? 0 : dropdown[0];
        } else {
            if ((lgt & c) > 0) {
                lgt = lgt ^ c;
            } else {
                lgt = lgt | c;
            }
        }

        if (lgt == allGameType) {
            lgt = -1;
        }

        dispatch(betSummarySliceActions.updateSelectedFilterType(lgt));
        playButtonAudio();
    };

    useEffect(() => {
        if (allGameType !== undefined) {
            const dropdowns = new Array<FilterType>();
            dropdowns.push(-1);
            // for (const cgt in CombineGameType) {
            for (const cgt in GameType) {
                const ncgt = getGameType(cgt);
                if (ncgt === GameType.MultiBet) continue;
                if (
                    !isNaN(ncgt) &&
                    (allGameType & ncgt) > 0 &&
                    dropdowns.indexOf(ncgt) < 0
                ) {
                    dropdowns.push(ncgt);
                    console.log('combine::game::type', ncgt);
                }
            }
            setDropdown(dropdowns);

            dispatch(
                betSummarySliceActions.updateSelectedFilterType(dropdowns[0])
            );
        } else {
            setDropdown([-1]);
        }
    }, [allGameType]);

    return (
        <Grid item className="game-type-selector">
            <Button
                aria-controls={open ? id : undefined}
                aria-haspopup={true}
                aria-expanded={open ? true : undefined}
                variant="contained"
                disableElevation
                onClick={handleOpen}
                endIcon={
                    open ? (
                        <ArrowDropUpIcon className="game-type-button-icon" />
                    ) : (
                        <ArrowDropDownIcon className="game-type-button-icon" />
                    )
                }
                className={`game-type-button ${open ? 'selected' : ''}`}
            >
                {selectedFilterType === dropdown[0] ? (
                    <Typography className="game-type-button-text">
                        {t(getString(-1))}
                    </Typography>
                ) : (
                    <Typography className="game-type-button-text">
                        {t('betlog.selectedGame')}
                    </Typography>
                )}
            </Button>
            <Menu
                id={id}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                slotProps={{
                    paper: {
                        className: 'game-type-selector-menu hide-scroll',
                        sx: {
                            width: anchorEl
                                ? (anchorEl as HTMLElement).offsetWidth
                                : 'auto',
                        },
                    },
                }}
            >
                {dropdown.map((c, i) => (
                    <MenuItem
                        onClick={() => handleChangeType(c)}
                        value={c}
                        key={`game-type-selector-${c}`}
                        className="game-type-selector-menu-item"
                    >
                        <Checkbox
                            className="game-type-selector-menu-item-check-box"
                            icon={
                                <CircleIcon className="game-type-selector-menu-item-check-box-icon uncheck" />
                            }
                            checkedIcon={
                                <CheckCircleOutlineIcon className="game-type-selector-menu-item-check-box-icon" />
                            }
                            checked={(selectedFilterType & c) === c}
                        />
                        <p className="game-type-selector-menu-item-text">
                            {t(getString(i === 0 ? -1 : c))}
                        </p>
                    </MenuItem>
                ))}
            </Menu>
        </Grid>
    );
};

const getString = (c: GameType | -1) => `betlog.gameCode.${c}`;
